var map = {
	"./gogo.dark.blue.scss": 491,
	"./gogo.dark.green.scss": 492,
	"./gogo.dark.orange.scss": 493,
	"./gogo.dark.purple.scss": 494,
	"./gogo.dark.red.scss": 495,
	"./gogo.light.blue.scss": 496,
	"./gogo.light.green.scss": 497,
	"./gogo.light.orange.scss": 498,
	"./gogo.light.purple.scss": 499,
	"./gogo.light.red.scss": 500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 490;